import React from 'react';
import {
  normalizeFreeItem,
  normalizeMealItems,
  normalizeRegularItems,
  normalizeUpsellItems,
} from '../orderManagementOrderHelpers';

function OrderInfoItemRow({ item, index }) {
  const name = String(item?.name ?? '—').trim();
  const qty = item?.qty ?? 1;

  return (
    <li className='otd-order-info__line'>
      <span className='otd-order-info__line-name'>
        {index + 1}. {name}
      </span>
      <span className='otd-order-info__line-qty'>{qty} qty</span>
    </li>
  );
}

function countTotalItemQty(...itemLists) {
  return itemLists.flat().reduce((sum, item) => {
    const qty = Number(item?.qty);
    return sum + (Number.isFinite(qty) && qty > 0 ? qty : 1);
  }, 0);
}

function ItemSection({ title, items }) {
  if (!items?.length) return null;
  return (
    <section className='otd-order-info__section'>
      <h4 className='otd-order-info__heading'>{title}</h4>
      <ul className='otd-order-info__list'>
        {items.map((item, index) => (
          <OrderInfoItemRow key={`${title}-${index}`} item={item} index={index} />
        ))}
      </ul>
    </section>
  );
}

function DriverCarrySection({ upsellItems, freeItems }) {
  const hasUpsell = upsellItems.length > 0;
  const hasFree = freeItems.length > 0;

  return (
    <section className='otd-order-info__driver-carry'>
      <h4 className='otd-order-info__driver-carry-title'>Driver must carry these items</h4>
      {hasUpsell ? (
        <div className='otd-order-info__driver-carry-group'>
          <p className='otd-order-info__subheading'>Upsell</p>
          <ul className='otd-order-info__list'>
            {upsellItems.map((item, index) => (
              <OrderInfoItemRow key={`upsell-${index}`} item={item} index={index} />
            ))}
          </ul>
        </div>
      ) : null}
      {hasFree ? (
        <div className='otd-order-info__driver-carry-group'>
          <p className='otd-order-info__subheading'>Standard delivery free items</p>
          <ul className='otd-order-info__list'>
            {freeItems.map((item, index) => (
              <OrderInfoItemRow key={`free-${index}`} item={item} index={index} />
            ))}
          </ul>
        </div>
      ) : null}
      {!hasUpsell && !hasFree ? (
        <p className='otd-order-info__empty'>No upsell or standard delivery free items</p>
      ) : null}
    </section>
  );
}

export function OrderMapOrderInfoPanel({ order }) {
  const regularItems = normalizeRegularItems(order?.item_names);
  const comboItems = normalizeMealItems(order?.meal_item_names);
  const upsellItems = normalizeUpsellItems(order?.upsale_item_names);
  const freeItems = normalizeFreeItem(order);
  const hasMenuItems = regularItems.length > 0 || comboItems.length > 0;
  const totalItems = countTotalItemQty(regularItems, comboItems, upsellItems, freeItems);

  return (
    <div className='otd-order-info'>
      {!hasMenuItems ? (
        <p className='otd-order-info__empty'>No items recorded</p>
      ) : (
        <>
          <ItemSection title='Regular menu' items={regularItems} />
          <ItemSection title='Combo menu' items={comboItems} />
        </>
      )}
      <DriverCarrySection upsellItems={upsellItems} freeItems={freeItems} />
      <p className='otd-order-info__total'>
        <span className='otd-order-info__total-label'>Total items</span>
        <span className='otd-order-info__total-count'>{totalItems}</span>
      </p>
    </div>
  );
}
